export function AutoCreatePurchaseCtrl ($uibModalInstance, $scope, $translate, messages, workshopAPI, vendor) {
  $scope.currentSupplier = false;
  $scope.vendor = vendor;

  $scope.orderList = {
    orderList: {
      item_code: $translate.instant('PRODUCT_SPACE.ITEM_CODE'),
      description: $translate.instant('PRODUCT_SPACE.DESCRIPTION'),
      location: $translate.instant('PRODUCT_SPACE.LOCATION'),
      group: $translate.instant('GENERAL_SPACE.FIELD.GROUP'),
      brand: $translate.instant('PRODUCT_SPACE.BRAND'),
      supplier: $translate.instant('VENDOR_SPACE.SUPPLIER')
    }
  };

  $scope.confirm = function () {
    workshopAPI.get('vendors/auto_create', [
      $scope.vendor.id || '*',
      $scope.settings.start_item_code,
      $scope.settings.end_item_code,
      $scope.type,
      $scope.currentSupplier
    ]).then(function (product) {
      $uibModalInstance.close(product);
    }).catch(function (err) {
      messages.error(err);
    });
  };

  $scope.updateSearchByField = function () {
    $scope.searchBySupplier = $scope.currentSupplier ? $scope.vendor.company_name : $translate.instant('VENDOR_SPACE.ALL_SUPPLIERS');
  };

  $scope.updateSearchByField();
};